import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

export default function WaitingVerify() {
  return (
    <div className={classNames('flex-row-nowrap', 'flex-center-center', styles.waitingVerify)}>
      <img src="//assets-oss.cbndata.com/cbndata-consume-brand/FoMQ_eSyqPClnejrCqJkmTF0Xm2Q.png" />
      <div className={styles.content}>
        <div className={styles.title}>您的认证正在审核中...</div>
        <div className={styles.subtitle}>您可以进行的操作:</div>
        <div className={styles.subtitle}>
          1. 联系我们的微信客服：<span className={styles.notice}>CBNDataDD4</span>
        </div>
        <div className={styles.subtitle}>
          2. 发送邮件申请到：<span className={styles.notice}>cbndatacs@yifinity.com</span>
        </div>
      </div>
    </div>
  );
}
